<template>
    <div class="field singleline" :class="{ 'required': required }">
        <div class="heading">
            <label>{{ label }}</label>
        </div>
        <div class="input">
            <input
                :type="type"
                :value="value"
                :placeholder="placeholder"
                @input="$emit('input', $event.target.value)"
            >
        </div>
        <p v-if="v && v.$error" class="error text--orange small semi">
            <template v-if="!v.required">This field is required</template>
            <template v-else-if="!v.email">Must be a valid email address</template>
        </p>
    </div>
</template>

<script>
export default {
    props: {
        required: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: null,
        },
        value: {
            type: [String, Number],
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
        v: {
            type: Object,
            default: null,
        }
    },
};
</script>

<style lang="scss" scoped>
    .error {
        margin-top: 0.5em;
    }
</style>
